import { useEffect, useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function ContactPage() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="relative min-h-screen bg-background-50">
      <Navbar />

      {/* Hero */}
      <section ref={sectionRef} className="relative pt-32 pb-16 md:pt-40 md:pb-24 px-6 md:px-12 lg:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="reveal opacity-0 mb-4">
            <span className="font-body text-xs font-semibold tracking-widest text-primary-500 uppercase">
              Contact
            </span>
          </div>
          <h1 className="reveal opacity-0 font-display text-4xl md:text-5xl lg:text-6xl font-medium text-foreground-50 leading-tight mb-6">
            Get in <span className="text-primary-500">Touch</span>
          </h1>
          <p className="reveal opacity-0 font-body text-base text-foreground-400 max-w-xl mx-auto mb-8">
            We are happy to see you on this page. Please tell us what project you want to do with us.
          </p>

          {/* Email card */}
          <div className="reveal opacity-0 max-w-sm mx-auto">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                <i className="ri-mail-line text-primary-500 text-lg" />
              </div>
              <h3 className="font-body text-sm font-semibold text-foreground-50 mb-1">Email</h3>
              <p className="font-body text-sm text-foreground-400">contactus@voxone.ai</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}